module.exports = __webpack_public_path__ + "img/Asset 12.3d1c2d5a.png";